






































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import VueRouter from "vue-router";
import { usePartnerUserStore } from "@/shared/store/partnerUser";

@Component ({
    components: {
      ErrorSummary
    }
  })
export default class PartnerNotificationEmailForm extends Vue {
  $router: VueRouter;
  $validator: Validator;

  partnerUserStore = usePartnerUserStore();

  @Prop() partnerId: number;

  // form fields
  email = "";

  mounted (): void {
    this.partnerUserStore.loadPartnerNotificationEmail().then(email => {
      this.email = this.partnerUserStore.notificationEmail;
    });
  }

  @Watch("partnerUserStore.notificationEmail")
  setNotificationEmail (): void {
    this.email = this.partnerUserStore.notificationEmail;
  }

  get submitDisabled (): boolean {
    return this.$validator.errors.any() || !this.partnerUserStore.isNotificationEmailLoaded || this.isUpdateDisabled;
  }

  clearForm (): void {
    this.email = "";

    this.$validator.reset();
  }

  submit (): void {
    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return;
        }
        this.partnerUserStore.partnerNotificationEmailSave(this.email);
      });
  }

  onUnsubscribeClick (): void {
    this.partnerUserStore.partnerNotificationEmailSave("").then(() => this.clearForm());
  }

  get showUpdateButton (): boolean { return !!this.partnerUserStore.notificationEmail; }
  get noUpdateChangesMade (): boolean { return !!this.email && this.email === this.partnerUserStore.notificationEmail; }
  get isUpdateDisabled (): boolean { return this.showUpdateButton && this.noUpdateChangesMade; }
  get shouldShowUnsubscribe (): boolean { return this.noUpdateChangesMade; }

  get saveButtonText (): string {
    return this.showUpdateButton ? "Update" : "Subscribe";
  }
}
